import React from 'react';
import PropTypes from 'prop-types';

import { Input, Select } from 'components/ui';

import * as Styled from './Address.styles';
import { getCountries } from 'utility/countries';

export const Address = ({ form }) => {
  const { values, errors, setFieldValue } = form;

  return (
    <Styled.Wrapper>
      <Styled.Row>
        <Input
          onChange={(value) => setFieldValue('address.street', value)}
          value={values.address.street}
          label="Ulica*"
          error={(errors.address || {}).street}
        />

        <Input
          onChange={(value) => setFieldValue('address.houseNumber', value)}
          value={values.address.houseNumber}
          label="Nr*"
          error={(errors.address || {}).houseNumber}
          className="smallInput"
        />

        <Input
          onChange={(value) => setFieldValue('address.apartmentNumber', value)}
          value={values.address.apartmentNumber}
          label="Lokal"
          error={(errors.address || {}).apartmentNumber}
          className="smallInput"
        />
      </Styled.Row>

      <Styled.Row>
        <Input
          onChange={(value) => setFieldValue('address.zipCode', value)}
          value={values.address.zipCode}
          label="Kod pocztowy*"
          error={(errors.address || {}).zipCode}
          className="smallInput"
        />

        <Input
          onChange={(value) => setFieldValue('address.city', value)}
          value={values.address.city}
          label="Miejscowość*"
          error={(errors.address || {}).city}
        />
      </Styled.Row>

      <Select
        onChange={(value) => setFieldValue('address.country', value)}
        value={values.address.country}
        label="Kraj*"
        error={(errors.address || {}).country}
        options={getCountries()}
      />
    </Styled.Wrapper>
  );
};

Address.propTypes = {
  form: PropTypes.object.isRequired,
};
